import { useSkuSelector } from '../hooks/useSkuSelector';

const TextContainer = ({ type }: any) => {
	const { showVariationsLabels = 'variation', showValueForVariation = 'none' } = useSkuSelector();

	return (
		<div className={`skuSelectorTextContainer vtex-store-components-3-x-skuSelectorTextContainer db mb3`}>
			{(showVariationsLabels === 'variation' || showVariationsLabels === 'variationAndItemValue') && (
				<span className={`skuSelectorName vtex-store-components-3-x-skuSelectorName c-muted-1 t-small overflow-hidden`}>
					{type}
				</span>
			)}
			{showValueForVariation !== 'none' && (
				<>
					<span
						className={`skuSelectorNameSeparator vtex-store-components-3-x-skuSelectorNameSeparator c-muted-1 t-small`}
					>
						:
					</span>
					<span
						className={`skuSelectorSelectorImageValue vtex-store-components-3-x-skuSelectorSelectorImageValue c-muted-1 t-small`}
					>
						&nbsp; Branco
					</span>
				</>
			)}
		</div>
	);
};

export default TextContainer;
